<template>
  <v-layout row justify-center>
    <v-dialog v-model="show" persistent max-width="500px">
      <v-card class="px-3">
        <v-card-title primary-title class="title">Set New Appointment</v-card-title>
        <v-card-text class="pa-0">
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-container grid-list-xs fluid>
              <v-layout row wrap>
                <v-flex xs12 v-if="patient.id" mb-2>
                  <label class="subheading grey--text" for="patient">Patient:</label>
                  <span class="mx-2 subheading">{{patient.name}}</span>
                </v-flex>
                <v-flex xs12 v-else>
                  <async-autocomplete
                    single-line
                    label="Patient"
                    v-model="patient_id"
                    :rules="[requiredRule]"
                    url="/api/patients/search"
                    required
                    item-value="id"
                    item-text="name"
                    dense
                  ></async-autocomplete>
                </v-flex>

                <v-flex xs12>
                  <!-- <async-autocomplete
                    single-line
                    label="Doctor"
                    v-model="doctor"
                    :rules="[requiredRule]"
                    url="/api/doctors/search"
                    required
                    item-value="id"
                    item-text="name"
                    dense
                  ></async-autocomplete>-->

                  <v-autocomplete
                    single-line
                    label="Doctor"
                    v-model="doctor"
                    :rules="[requiredRule]"
                    required
                    item-value="id"
                    item-text="name"
                    dense
                    :items="doctors"
                  ></v-autocomplete>
                </v-flex>

                <v-flex xs12>
                  <v-text-field
                    single-line
                    label="Fee"
                    v-model="fee"
                    :rules="[requiredRule]"
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <date-picker
                    single-line
                    label="Date"
                    v-model="date"
                    :rules="[requiredRule]"
                    required
                  ></date-picker>
                </v-flex>

                <v-flex xs12 class="text-xs-right mt-3">
                  <v-btn flat @click="clean">Cancel</v-btn>

                  <v-btn
                    class="mx-0"
                    :loading="loading"
                    color="primary"
                    @click="submit"
                    :disabled="!valid"
                  >Save</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import moment from "moment";
export default {
  props: {
    visibility: {
      type: Boolean,
      required: true
    },
    patient: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      loading: false,
      valid: true,
      date: moment().format("YYYY-MM-DD"),
      fee: 250,
      doctor: "",
      patient_id: "",

      requiredRule: v => !!v || "This field is required."
    };
  },

  computed: {
    show: {
      get() {
        return this.visibility;
      },
      set(value) {
        this.$emit("update:visibility", value);
      }
    },
    doctors() {
      return this.$store.getters["doctors/get"];
    }
  },

  methods: {
    clean() {
      this.show = false;
      this.$refs.form.reset();
      this.patient_id = "";
      this.doctor = "";
      this.fee = 250;
      this.date = "";
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;

        this.axios
          .post("/api/appointments", {
            patient_id: this.patient.id || this.patient_id,
            doctor_id: this.doctor,
            fee: this.fee,
            date: this.date
          })
          .then(app => {
            this.clean();
            this.$emit("saved", app);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  },
  mounted() {
    this.$store.dispatch("doctors/get");
  }
};
</script>